import { a as c } from "./chunk-BaseElement-BuXbltG-.js";
import { d } from "./chunk-debounce-Bk6yKvzA.js";
import { W as h } from "./chunk-WithShopifyCart-CoFAHix4.js";
import { t as f } from "./chunk-custom-element-ttkHUa8w.js";
import "./chunk-lit-element-CNHURX5C.js";
var u = Object.defineProperty, p = Object.getOwnPropertyDescriptor, b = (t, e, i, s) => {
  for (var r = s > 1 ? void 0 : s ? p(e, i) : e, l = t.length - 1, o; l >= 0; l--)
    (o = t[l]) && (r = (s ? o(e, i, r) : o(r)) || r);
  return s && r && u(e, i, r), r;
};
const a = "_filter_collapsed";
let n = class extends h(
  c
) {
  constructor() {
    super(), this.handleToggle = this.handleToggle.bind(this), this._debouncedScrollHandler = d(this.handleScroll.bind(this), 100), this.formContainer = this.querySelector("facet-filters-form"), this.facetList = this.querySelector("[data-filter-facet-list]");
  }
  connectedCallback() {
    super.connectedCallback(), this._initListeners();
  }
  _initListeners() {
    var t;
    document.addEventListener("facet-drawer:toggle", this.handleToggle), (t = this.facetList) == null || t.addEventListener("scroll", this._debouncedScrollHandler);
  }
  disconnectedCallback() {
    var t;
    super.disconnectedCallback(), document.removeEventListener("facet-drawer:toggle", this.handleToggle), (t = this.facetList) == null || t.removeEventListener("scroll", this._debouncedScrollHandler);
  }
  open() {
    this.setAttribute("aria-expanded", "true"), this.updateCartNoteAndAttributes(
      {
        attributes: {
          [a]: "1"
        }
      },
      { sections: !1 }
    );
  }
  close() {
    this.setAttribute("aria-expanded", "false"), this.updateCartNoteAndAttributes(
      {
        attributes: {
          [a]: "0"
        }
      },
      { sections: !1 }
    );
  }
  handleToggle() {
    this.getAttribute("aria-expanded") !== "true" ? this.open() : this.close();
  }
  handleScroll() {
    var e, i;
    if (!this.facetList) return;
    this.facetList.scrollHeight - (this.facetList.scrollTop + this.facetList.clientHeight) <= 25 ? (e = this.formContainer) == null || e.setAttribute("data-end-of-scroll", "") : (i = this.formContainer) == null || i.removeAttribute("data-end-of-scroll");
  }
};
n = b([
  f("filters-drawer")
], n);
export {
  n as FiltersDrawer
};
